<script setup lang="ts">
import { KsDialogOverlay } from '@aschehoug/kloss-2'

defineProps<{ imageUrl?: string }>()
</script>

<template>
  <KsDialogOverlay
    class="dialog-overlay"
    :class="{ 'has-background': !!imageUrl }"
    :style="{ backgroundImage: !!imageUrl ? `url(${imageUrl})` : '' }"
  >
    <slot />
  </KsDialogOverlay>
</template>

<style scoped lang="scss">
  .dialog-overlay {
    position: fixed;
    inset: 0;
    animation: overlay-show 250ms cubic-bezier(.16, 1, .3, 1);
    z-index: 1000;
  }

  .dialog-overlay::after {
    content: '';
    position: absolute;
    inset: 0;
    background-color: rgba(0 0 0 / 50%);
  }

  .has-background {
    background-size: cover;
  }

  @keyframes overlay-show {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
</style>
